<template>
    <div class="giveChange" name="giveChange">
        <topNav v-show="topShow" :title="title"></topNav>
        <div class="informinfo" v-for="(item, index) in payParams" :key="index">
            <div class="orderdetail">
                <p><span class="leftinfo">订单号</span><span class="rightinfo">{{ item.tradeno }}</span></p>
                <p><span class="leftinfo">车牌号</span><span class="rightinfo">{{ item.vehicleno }}</span></p>
                <p><span class="leftinfo">找零金额</span><span class="rightinfo">{{ item.totalfee }}元</span></p>
            </div>
            <h4>请在倒计时结束内领取，否则将领取失败。</h4>
            <div id="cdTimerDom">
            </div>
            <div class="pay_btn" @click="getMoney">领取</div>
            <div class="tips">
                <h5>注意事项：</h5>
                <p>零钱仅支持本人领取，分享无效。</p>
            </div>
        </div>

    </div>

</template>
<script>
import topNav from "../topnav/topnav"
import { DETAIL as API } from "@/assets/api";
export default {
    name: 'giveChange',
    components: {
        topNav,
    },
    data() {
        return {
            title: "找零领取",
            payParams: [],
            topShow: true
        }
    },
    created() {
        let tradeno = this.$route.query.tradeno;
        let totalfee = this.$route.query.totalfee;
        let vehicleno = this.$route.query.vehicleno;
        let timestamp = this.$route.query.timestamp;
        this.payParams.push({
            "tradeno": tradeno,//订单号
            'totalfee': totalfee,//找零金额
            'vehicleno': vehicleno,//车牌号
            'startTime': timestamp
        })
        this.countDownNext()
    },
    methods: {
        addZero(value) {
            if (value < 10) return '0' + value
            else return value
        },
        countDownNext() {
            const that = this
            var nowtime = new Date().getTime(),  //获取当前时间毫秒数
                endtime = new Date(this.$route.query.timestamp).getTime();  //定义结束时间毫秒数
            endtime = endtime + 1000 * 60 * 10
            var showtime = function () {
                var lefttime = endtime - nowtime,  //距离结束时间的毫秒数
                    lefth = Math.floor(lefttime / (1000 * 60 * 60) % 24),  //计算小时数
                    leftm = Math.floor(lefttime / (1000 * 60) % 60),  //计算分钟数
                    lefts = Math.floor(lefttime / 1000 % 60);  //计算秒数
                //lefttime判断如果结束时间已过返回00：00:00
                if (lefttime > 0) {
                    //leftd判断如果不超过24小时，不显示天数
                    //that.addZero()调用vue中的过滤器，如上filters
                    return that.addZero(lefth) + "时" + that.addZero(leftm) + "分" + that.addZero(lefts) + "秒"
                } else {
                    return '00时00分00秒'
                }
            }
            setInterval(function () {
                var cdTimerDom = document.getElementById('cdTimerDom')
                var time = showtime()//获取要显示的时间字符串
                var domHtml = ''
                //遍历时间字符串
                for (var i = 0; i < time.length; i++) {
                    //判断样式的，不同位置返回不同的样式
                    if (i == 2 || i == 5 || i == 8) {
                        domHtml += `<div style="width: 1.5rem;
              background-color: #ffffff;
              border-radius: 4px;
              text-align: center;
              color: rgb(70, 135, 248);
              margin-right: 2px;
              line-height: 1.5rem;"> ${time[i]}</div>`
                    } else {
                        domHtml += `<div style="width: 1.5rem;
              background-color: rgb(70, 135, 248);
              border-radius: 4px;
              text-align: center;
              color: #ffffff;
              margin-right: 2px;
              line-height: 1.5rem;"> ${time[i]}</div>`
                    }
                }
                cdTimerDom.innerHTML = domHtml
                nowtime = nowtime + 1000
            }, 1000);  //反复执行函数本身
        },
        getMoney() {
            let originalId = this.$store.state.originalId;
            let req = {
                originalid: originalId,
                tradeno: this.$route.query.tradeno,
            }
            this.$http({
                method: 'post',
                url: API.GET_TRANSFER,
                data: this.qs.stringify(req),
                success: function (data) {
                    if (data.code == 0) {
                        this.$dialog.alert({
                            title: '领取成功',
                        });
                    } else {
                        this.$dialog.alert({
                            title: '提示',
                            message: data.msg
                        });
                    }
                }.bind(this),
                error: function (error) {
                    console.log(error)
                }
            })
        },
    },

}
</script>
<style>
.giveChange {
    background: white;
    height: 100%;
    width: 100%;
}

.informinfo p {
    width: 92%;
    margin: 0 auto;
    padding: 10px 0;
    font-size: 15px;
}

.informinfo .leftinfo {
    display: inline-block;
    width: 30%;
    text-align: left;
}

.informinfo .rightinfo {
    display: inline-block;
    width: 70%;
    text-align: right;
}

.pay_btn {
    width: 92%;
    text-align: center;
    height: 3rem;
    line-height: 3rem;
    background-color: rgb(70, 135, 248);
    color: white;
    margin: 1.5rem auto;
    border-radius: 5px;
    font-size: 1.1rem;
    box-shadow: 0rem 0.2em 0.8rem #5b82c18a;
}

h4 {
    margin-top: 1.5rem;
}

#cdTimerDom {
    display: flex;
    width: 50%;
    margin: 1.5rem auto;
}

.tips {
    width: 92%;
    margin: 1rem auto 0;
    text-align: left;
    color: #dd001b;

}

.tips h5 {
    font-size: 14px;
    line-height: 16px;
    vertical-align: middle;
}

.tips p {
    font-size: 12px;
    line-height: 16px;
    vertical-align: middle;
}
</style>


// WEBPACK FOOTER //
// src/components/paydetail/giveChange.vue